<app-toaster></app-toaster>
<p-confirmdialog />
<ngx-ui-loader></ngx-ui-loader>
<router-outlet></router-outlet>
